module.exports = __webpack_public_path__ + "static/media/Balance.cb545b49.svg";